<template>
  <v-dialog v-model="dialogComp" persistent max-width="500px">
    <v-card>
      <v-toolbar dense flat dark color="primary">
        <v-btn icon dark @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title class="pl-0">Importar progressió</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn class="mr-4" @click="resetForm" small outlined>
          Reiniciar
        </v-btn>
        <v-btn type="submit" form="importaProgressio" small depressed light>
          Importar
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row>
            <v-form
              id="importaProgressio"
              class="my-2"
              @submit.prevent="submitForm"
              ref="form"
            >
              <v-col cols="12">
                <v-select
                  v-model="progressionSelector"
                  :items="progressions"
                  :rules="[v => !!v || 'Camp obligatori']"
                  label="progressió"
                  item-text="nom"
                  item-value="id"
                />
              </v-col>
            </v-form>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import MesocicleService from "@/services/MesocicleService";

export default {
  data() {
    return {
      progressionSelector: null,
    }
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    idSessio: {
      type: Number,
      default: null,
    },
    progressions:{
      type: Array,
      required: true,
    }
  },
  methods: {
    cancel() {
      this.closeDialog()
    },
    closeDialog() {
      this.$emit("toggleImportacioProgressioDialog")
    },
    resetForm() {
      this.progressionSelector = null
    },
    validate() {
      return this.$refs.form.validate()
    },
    submitForm() {
      if (!this.validate()) {
        return
      }
      const params = {
        session_id: this.idSessio,
        progression_id: this.progressionSelector,
      }
      MesocicleService.importProgressio(params)
        .then(() => {
          this.$root.$emit("refreshBoard")
          this.closeDialog()
          this.$notify({
            type: "success",
            title: this.$store.state.commonText.notification.successTitle,
            text: this.$store.state.commonText.notification.successText,
          })
        })
        .catch(error => {
          this.$notifyErrorByStatusCode(error.response.status)
        })
    },
  },
  computed: {
    dialogComp: {
      get() {
        this.resetForm()
        return this.dialog
      },
      set() {
        this.closeDialog()
      },
    },
  },
}
</script>

<style lang="scss">
.prd-dialog-spinner {
  margin-left: auto;
  margin-right: auto;
}
</style>
